import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_attribute_set_attribute_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  attribute_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_position: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_mst_attribute_set_attribute_link_RowClass
  implements bl_fi_mst_attribute_set_attribute_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  attribute_set_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_hdr_guid: fromDatatype.GuidDataFieldInterface;
  attribute_position: fromDatatype.TextDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
